import { GET_USER_FROM_SESSION } from 'actions/Types';

export default (state = null, action) => {
  if (action.type === `${GET_USER_FROM_SESSION}_SUCCESS`) {
    const user = action.payload;

    if (!user) return false;

    return user.teams.filter(t => t.role === 'admin').length > 0;
  }

  return state;
};
